import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { formatApiError } from '../api';
import { can as canHelper } from '../lib/permissions';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refreshUser = useCallback(() => {
        return api.get('/auth/me')
            .then((r) => { setUser(r.data); return r.data; })
            .catch(() => { setUser(null); return null; });
    }, []);

    useEffect(() => {
        refreshUser().finally(() => setLoading(false));
    }, [refreshUser]);

    const login = useCallback(async (email, password) => {
        try {
            await api.post('/auth/login', { email, password });
            // Re-fetch /me to pick up effective_permissions
            await refreshUser();
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiError(e?.response?.data?.detail) || e.message };
        }
    }, [refreshUser]);

    const logout = useCallback(async () => {
        try { await api.post('/auth/logout'); } catch { /* ignore */ }
        setUser(null);
    }, []);

    const can = useCallback((module, action) => canHelper(user, module, action), [user]);

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, can, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
